import * as z from "zod";
import { promotionAgendaItemSchema } from "./items/promotion";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { TeamCalendarEntryAgendaItemType } from "./agenda-item-type";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { promotionAgendaItemSchema } from "./items/promotion";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type { PromotionAgendaItem } from "./items/promotion";

const TeamCalendarEntryAgendaItemSchema_ = z.discriminatedUnion("type", [
  promotionAgendaItemSchema,
]);

export type TeamCalendarEntryAgendaItem = z.infer<
  typeof TeamCalendarEntryAgendaItemSchema_
>;

export const TeamCalendarEntryAgendaItemSchema: z.ZodType<TeamCalendarEntryAgendaItem> =
  TeamCalendarEntryAgendaItemSchema_;
